import { withState } from 'recompose';

export default withState('lastName', 'updateLastName', '');
